import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { joinPaths } from "@/mocks/siteData";

const themeMap: Record<string, { icon: string; button: string; badge: string }> = {
  primary: {
    icon: "bg-primary-100 text-primary-700",
    button: "bg-primary-500 text-background-50 hover:bg-primary-600",
    badge: "text-primary-700",
  },
  accent: {
    icon: "bg-accent-100 text-accent-700",
    button: "bg-accent-500 text-background-50 hover:bg-accent-600",
    badge: "text-accent-700",
  },
  secondary: {
    icon: "bg-secondary-100 text-secondary-800",
    button: "bg-secondary-500 text-background-50 hover:bg-secondary-600",
    badge: "text-secondary-700",
  },
  foreground: {
    icon: "bg-background-200 text-foreground-800",
    button: "bg-foreground-900 text-background-50 hover:bg-foreground-800",
    badge: "text-foreground-700",
  },
};

export default function JoinSection() {
  return (
    <section id="join" className="sun-glaze bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              Join the Journey
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
            There's a Path for Everyone
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {joinPaths.map((path, index) => {
            const theme = themeMap[path.theme] || themeMap.primary;
            return (
              <Reveal key={path.label} delay={(index % 4) * 90}>
                <article className="h-full bg-background-100 rounded-lg border border-background-200 p-7 flex flex-col">
                  <span
                    className={`w-12 h-12 flex items-center justify-center rounded-full ${theme.icon}`}
                  >
                    <i className={`${path.icon} text-2xl`}></i>
                  </span>
                  <p className={`text-xs font-semibold uppercase tracking-wider mt-5 ${theme.badge}`}>
                    {path.label}
                  </p>
                  <p className="text-base text-foreground-800 leading-relaxed mt-3 flex-1">
                    {path.title}
                  </p>
                  <a
                    href={path.href}
                    className={`mt-6 inline-flex items-center justify-center gap-2 text-sm font-semibold px-5 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer ${theme.button}`}
                  >
                    {path.cta}
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}